@if (featureEnabled && (userService.isAuthenticated$ | async)) {
  <div class="flex flex-row surface-0 border-round min-w-full w-20rem flex-grow-1">
    <!-- A decorative icon, not a button: the search runs from the input itself, so a
         pButton here only invites clicks that do nothing (issue #371). Mirrors home-search. -->
    <i class="pi pi-search search-adornment"></i>
    <p-autocomplete
      inputId="main-menu-search-ac"
      [(ngModel)]="selectedResult"
      [suggestions]="autoCompleteResults"
      (completeMethod)="autocompleteSearch($event)"
      [dropdown]="false"
      name="mainMenuSearchAutocomplete"
      class="autocomplete-left flex-grow-1"
      placeholder="Search for lipids, studies or datasets"
      emptyMessage="No results"
      [showEmptyMessage]="true"
      [autoHighlight]="false"
      [autofocus]="false"
      field="displayLabel"
      [fluid]="true"
      appendTo="body"
      panelStyleClass="global-search-overlay"
      (onSelect)="handleSelect($event)"
      (onUnselect)="handleUnSelect($event)"
      ><ng-template let-result #item>
      <div class="flex items-center gap-2 gs-search-row">
        @if (result.kind === 'lipid') {
          <i class="fas fa-sitemap" style="color: var(--p-blue-500)"></i>
        } @else if (result.kind === 'study') {
          <i class="fa fa-vials" style="color: #d73027"></i>
        } @else if (result.kind === 'dataset') {
          <i class="fa fa-box-archive" style="color: #f46d43"></i>
        }
        <span class="gs-search-label" [title]="result.displayLabel">{{ result.displayLabel }}</span>
        @if (result.subLabel && result.subLabel !== result.displayLabel) {
          <span class="text-sm gs-search-sublabel" style="color: var(--p-text-muted-color)">&nbsp;({{ result.subLabel }})</span>
        }
      </div>
    </ng-template>
  </p-autocomplete>
</div>
}
